import React, { Component, useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import client, { setToken } from "@culturehq/client";

import { useProfile } from "app/context";
import { errorService, mobileAndTabletCheck, parseQueryString } from "app/utils";
import getSubdomain from "app/utils/getSubdomain";

class SSOContext extends Component {
  constructor(props) {
    super(props);

    const { location: { search }, match: { params: matchParams } } = props;
    const searchParams = parseQueryString(search);

    // This is for migration purposes. At some point this should switch over to
    // just use the match parameters, but for while we're not sure if people
    // have the latest version, we're still going to direct them to /sso and
    // just use query parameters.
    const token = matchParams.token || searchParams.token;

    if (token) {
      setToken(token);
      this.state = { redirect: null };
      this.fetchProfile();
    } else {
      errorService.log("Redirect to login, sso");
      this.state = { redirect: "/login" };
    }
  }

  redirectUrl = () => {
    const { location, match: { params: { token } } } = this.props;

    const path = location.pathname.split(token);
    if (path.length > 1 && path[1].length > 0 && path[1] !== "/undefined") {
      return `${path[1]}${location.hash}`;
    }

    return "/";
  };

  fetchProfile = async () => {
    const { fetchedProfile, location } = this.props;

    try {
      const { user } = await client.getProfile();

      fetchedProfile(user);
      if (user.claimed) {
        this.setState({ redirect: user.organizations.length > 1 ? "/profile/organizations" : this.redirectUrl() });
      } else {
        this.setState({ redirect: `/accept${location.pathname}${location.hash}` });
      }
    } catch (error) {
      this.setState({ redirect: "/" });
    }
  };

  render() {
    const { redirect } = this.state;

    return redirect ? <Redirect to={redirect} /> : null;
  }
}

const SSO = ({ match, ...props }) => {
  const { fetchedProfile } = useProfile();
  const location = useLocation();

  useEffect(
    () => {
      if (mobileAndTabletCheck()) {
        try {
          window.location.assign(`mobile://sso/${match.params.token}`);
        } catch (err) {
          window.location.assign(`https://${getSubdomain()}.culturehq.com${location.pathname}`);
        }
      }
    }, [location.pathname, match.params.token]
  );

  return (
    <SSOContext
      {...props}
      match={match}
      fetchedProfile={fetchedProfile}
      location={location}
    />
  );
};

export default SSO;
